import { withVersions } from "v2/hocs/withVersions";
import SearchDrawerV1 from "./SearchDrawer/v1";
import SearchDrawerV2 from "./SearchDrawer/v2";
import withSearchDrawer from "../hocs/withSearchDrawer";

const SearchDrawer = withVersions({
  v1: withSearchDrawer(SearchDrawerV1),
  v2: withSearchDrawer(SearchDrawerV2),
});

export default SearchDrawer;
